module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0076.jpg?v=eed3134b";